import { AxiosHeaders, AxiosRequestConfig } from "axios";
import { v4 as uuidv4 } from "uuid";

import { getConfig } from "merchant-portal-frontend/src/config";

interface RequestConfig {
	isAuthenticated?: boolean;
	headers?: AxiosHeaders;
}

export const getRequestConfig = (config?: RequestConfig): { request: AxiosRequestConfig } => {
	const { headers, isAuthenticated = true } = config ?? {};
	return {
		request: {
			baseURL: getConfig("apiurl"),
			isAuthenticated,
			headers: {
				...headers,
				"X-Request-ID": uuidv4(),
			},
		},
	};
};
